import React, { PureComponent } from 'react';
import Head from 'next/head';
import styled from 'styled-components';
import { Query } from 'react-apollo';
import { withI18N } from '../../src/hoc';
import { Page, Main } from '../../src/components/Layout';
import { Header } from '../../src/components/Header';
import { Container } from '../../src/components/Grid';
import Breadcrumb from '../../src/components/Breadcrumb';
import { ParallaxProvider } from 'react-scroll-parallax';
import Watermark from '../../src/components/Parallax/Watermark';
import createContext from '../../src/utils/format/createContext';
import getPageByType from '../../src/apollo/graphql/page/getPageByType';
import Questions from './Questions';

const FAQMain = styled(Main)`
  overflow: hidden;
`;

class FAQ extends PureComponent {
  render() {
    const { t, i18n } = this.props;
    return (
      <Page faq>
        <Query
          query={getPageByType}
          variables={{ type: 'question' }}
          context={createContext(i18n.language)}
        >
          {({ loading, error, data }) => {
            if (!loading && !error && data && data.getPageByType) {
              const page = data.getPageByType;
              return (
                <div>
                  <Head>
                    <title key="title">
                      Grand Hôtel-Dieu - {page.detail.title}
                    </title>
                  </Head>
                  <Header
                    title={page.detail.title}
                    image={page.img_header_desktop}
                    imageMobile={page.img_header_mobile}
                  />
                  <FAQMain>
                    <Container>
                      <Breadcrumb
                        items={[
                          { href: '/', label: t('common:nav.tabs.home') },
                          { label: page.detail.title }
                        ]}
                      />
                    </Container>
                    <Questions />
                  </FAQMain>
                </div>
              );
            }

            return null;
          }}
        </Query>
      </Page>
    );
  }
}

export default withI18N()(FAQ);
